import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { sharedColors } from '../../../sharedStyles/styles'

const channel: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '10px 20px 20px 20px',
}

const avatar: CSSObject = {
  border: `1px solid ${sharedColors.lightGray}`,
  marginBottom: '8px',
}

const coverAsset: CSSObject = {
  height: '104px',
  width: '375px',
}

const accountName: CSSObject = {
  fontWeight: fontWeights.bold,
  letterSpacing: '-0.5px',
  marginBottom: '10px',
}

const subscribeBtn: CSSObject = {
  color: sharedColors.red,
  fontSize: fontSizes.xSmall,
  fontWeight: fontWeights.bold,
  letterSpacing: '0px',
  marginBottom: '12px',
  textTransform: 'uppercase',
}

const footer: CSSObject = {
  color: sharedColors.black,
  fontSize: fontSizes.xxSmall,
}

const styles = {
  avatar,
  accountName,
  coverAsset,
  channel,
  subscribeBtn,
  footer,
}

export { styles }
